import api, { apiSetup } from '../api';

apiSetup();

export class FuentesService {
  BASE_URL = '/sources';

  get() {
    return api.get(this.BASE_URL);
  }
}
